import qs from 'qs';
import { toUnderscoreObject } from 'helpers/toUnderscore';
import dotToPath from 'helpers/dotToPath';
import cleanDeep from 'clean-deep';
import { IS_SNAP, SNAP_SHOT_LIMIT } from 'variables/main';

const vacanciesEndPoint = {
  dataURL: 'vacancies',
  sourceName: 'vacanciesList',
  autoLoad: true,
  getDataUrl: (url, { page, perPage, filters = {}, sort, search }) => {
    const { name, ...filtersRest } = filters;
    const urlData = {
      filters: toUnderscoreObject(dotToPath({ ...filtersRest, search: name }), false),
      sort
    };

    if (search) {
      urlData.search = search;
    }

    const offset = ((page || 1) - 1) * perPage;

    urlData.offset = offset;

    urlData.limit = IS_SNAP ? SNAP_SHOT_LIMIT : perPage;

    if (urlData?.filters?.noexperience === false) {
      delete urlData.filters.noexperience;
    }

    const queryString = qs.stringify(cleanDeep(urlData, { NaNValues: true }));

    return url + (queryString && '?' + queryString);
  },
  mapData: (payload, state, concat) => {
    if (!payload || typeof payload !== 'object') {
      return {
        data: [],
        page: state?.page || 1,
        perPage: state?.perPage || 6,
        count: 0
      };
    }
    const meta = payload.meta || {};
    const { limit, count, offset } = meta;
    // API returns objectProxy(array) with .meta - Proxy fails Array.isArray
    let items = [];
    try {
      if (Array.isArray(payload)) {
        items = [...payload];
      } else if (Array.isArray(payload?.data)) {
        items = payload.data;
      } else if (payload && typeof payload[Symbol.iterator] === 'function') {
        items = Array.from(payload);
      }
    } catch (_) {
      items = [];
    }
    const safeLimit = limit > 0 ? limit : state?.perPage || 6;
    const safeOffset = Number.isFinite(offset) ? offset : 0;

    return {
      data: concat ? (state.data || []).concat(items) : items,
      page: Math.ceil(Number(safeOffset) / Number(safeLimit)) + 1,
      perPage: safeLimit,
      count: count != null ? count : 0
    };
  }
};

export default vacanciesEndPoint;
